import "./style.css";

import Loading from "component/layout/loading/spinner/Loading";
import Stateless from "component/Stateless";
import { observer } from "mobx-react";
import * as React from "react";

import loadingStore from "./fullScreenLoadingStore";

/**
 * https://dn9x.github.io/loading.js/
 */

@observer
export default class FullScreenLoading extends Stateless<{}> {
  public render(): JSX.Element {
    const { loading } = loadingStore;
    if (!loading) {
      return null;
    }
    return <Loading />;
  }
}
